module.exports = __webpack_public_path__ + "public/images/slider/speaker-2.5b8ebc76e4a88c22769b2b00ec6523bd.jpg";